<template>
  <div>
    <ValidationProvider
      v-if="hasValidator"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors }">
        <b-field
          v-bind="$attrs"
          :type="{ 'is-danger': errors[0] }"
          :message="errors">
            <b-taginput
              v-model="selected"
              :data="filterTasks"
              autocomplete
              :open-on-focus="true"
              field="name"
              type="is-primary"
              :maxtags="1"
              :has-counter="false"
              icon="label"
              placeholder="Selecciona una tarea"
              @typing="task = $event" :loading="isLoading">
                <template slot-scope="props">{{props.option.name}}</template>
            </b-taginput>
        </b-field>
    </ValidationProvider>
    <b-taginput
      v-else
      v-model="selected"
      :data="filterTasks"
      autocomplete
      :open-on-focus="true"
      field="name"
      type="is-primary"
      :maxtags="1"
      :has-counter="false"
      icon="label"
      placeholder="Selecciona una tarea"
      @typing="task = $event" :loading="isLoading">
        <template slot-scope="props">{{props.option.name}}</template>
    </b-taginput>
  </div>
</template>

<script>
import TaskService from '@/services/TaskService'

export default {
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    hasValidator: {
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      default: null,
      type: Number
    }
  },
  created () {
    this.getTasks()
  },
  data () {
    return {
      task: '',
      selected: null,
      tasks: [],
      isLoading: false
    }
  },
  methods: {
    async getTasks () {
      this.isLoading = true
      let response = await TaskService.getTasks()
      this.tasks = response.data.data
      if (this.value) {
        this.selected = this.tasks.filter((x) => x.id === this.value)
      }
      this.isLoading = false
    }
  },
  computed: {
    filterTasks () {
      return this.tasks.filter((task) => {
        return `${task.name}`
          .toString()
          .toLowerCase()
          .indexOf(this.task.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    selected () {
      this.$emit('select', this.selected[0])
    }
  }

}
</script>
